/**
 * This is a file where you can place various analytics codes
 * Do not duplicate event handlers if you want to add code, add code within the callback
 */

$(document).ready(function () {

    /**
     * This event is triggered when a product is added to the cart
     */
    $(document).on('product-add-to-cart', function (evt, product) {
        // uncomment below to see what variables are available
        //console.log(product);
        fbq('track', 'AddToCart', {
            content_name: product.product_title,
            content_category: product.product_type,
            content_ids: [product.id],
            content_type: 'product',
            value: shop.currency.formatMoney(product.price, shop.strings.moneyFormat),
            currency: shop.strings.currency
        });
    });

    /**
     * This event is triggered when a product is added to the wishlist
     * - only properties handle and title are available here
     * - e.g. product.handle, product.title
     */
    $(document).on('product-add-to-wishlist', function (evt, product) {
        fbq('track', 'AddToWishlist', {
            content_name: product.title,
            content_type: 'product',
        });
    });

    /**
     * This event is triggered when a product is viewed
     */
    productViewEvent(function (product) {
        // uncomment below to see what variables are available
        //console.log(product);
        fbq('track', 'ViewContent', {
            content_name: product.title,
            content_category: product.type,
            content_ids: [product.id],
            content_type: 'product',
            value: shop.currency.formatMoney(product.price, shop.strings.moneyFormat),
            currency: shop.strings.currency
        });
    });

});

function productViewEvent(callback) {
    if (!$('body').hasClass('template-product')) {
        return;
    }
    let productSectionId = $('.product-single').attr('data-section-id');
    if (!$('#ProductJson-' + productSectionId).html()) {
        return;
    }
    let data = JSON.parse(
        document.getElementById('ProductJson-' + productSectionId).innerHTML
    );
    callback(data);
}
